import React from 'react';
import { navigate } from 'gatsby';
import { sendEvent } from '../../actions/analytics';
import { useLiv } from '../../context/liv';

const LiviaNav = () => {
  const { askId, setAskId } = useLiv();

  const onNew = () => {
    sendEvent('reset', {
      ask_id: askId,
    });
    setAskId(null);
    navigate('/new');
  };
  return (
    <nav>
      <ul>
        <li className="my-2">
          <a href="#new" onClick={onNew}>
            Demander à Livia
          </a>
        </li>
      </ul>
    </nav>
  );
};

export { LiviaNav };
